import React from "react";

import {Typography} from "../../../../designSystem/components/Typography";
import {Paragraph} from "../../../../designSystem/components/Paragraph";
import {GoBackNavigationIconButton} from "../../../../widgets/GoBackNavigationIconButton";

export const PrivacyTermsFeature = () => (
  <div className="p-8 flex flex-col gap-y-6">
    {/* Go back button */}
    <div className="self-start">
      <GoBackNavigationIconButton />
    </div>

    {/* Title */}
    <div className="flex flex-col gap-y-4">
      <Typography variant="title" align="center">
        屏東遠距醫療諮詢
      </Typography>
      <Typography variant="title" align="center">
        隱私權政策
      </Typography>
    </div>

    {/* Content */}
    <div>
      <Paragraph
        text={`「屏東遠距醫療諮詢」\n(以下簡稱「本服務」)十分重視會員的隱私權且遵循「個人資料保護法」之規定，為保護您的隱私權，請您詳細閱讀以下有關本服務之「隱私權政策」，請注意，本《隱私權政策》會不定時變更。我們不會在未經您同意的情況下，削減本《隱私權政策》賦予您的權利，並且會隨時在本服務登載最新版本的《隱私權政策》，提供您隨時查閱。`}/>
      <Paragraph text="一、個人資料蒐集、處理、利用及修改"/>
      <Paragraph tab={1} text="1.個人資料之蒐集與目的"/>
      <Paragraph tab={1} text={`
              蒐集之目的：當您造訪使用本平台提供之服務時，我們將視該服務所提供之性質，請您提供必要的個人資料，並在平台特定的目的範圍內處理及利用您所提供的個人資料。
              蒐集之個人資料類別：在您加入會員或下載、使用本服務相關服務時，軟體系統將依您所要求的服務內容，擷取提供該等服務所必須蒐集之可供辨識個人之資料（姓名、手機、電話、Email、生日、居住地、身分證字號等），若您係以企業用戶之成員身分使用本服務相關服務者，除前述資料外，軟體系統將擷取您所撥打的通訊號碼暨時間提供予企業用戶，以利企業用戶分析使用情形與核計帳款，詳細擷取資料在您下載本服務時業已取得您的同意。倘若您不同意提供上述個人資料，請勿繼續使用本服務。
              利用期間、地區、對象及方式：
            `}/>
      <Paragraph tab={2} text="• 期間：會員當事人要求停止使用或本服務停止提供服務之日為止。"/>
      <Paragraph tab={2} text="• 地區：會員之個人資料將用於中華民國地區使用。"/>
      <Paragraph tab={2}
                 text="• 利用對象及方式：會員之個人資料蒐集除用於本服務之會員管理、客戶管理之檢索查詢、各項相關服務之使用等功能外，亦將利用於辨識身份、金流服務、物流服務、行銷廣宣等。"/>
      <Paragraph tab={1} text="2.個人資料之處理及利用"/>
      <Paragraph tab={1}
                 text="當系統擷取您的個人資料時起至您要求刪除時止，您的個人資料會被我們蒐集、並安全地集體儲存在本服務會員資料庫系統中，供軟體系統使用、處理，用以進行科技管理、資(通)訊業務與資料庫管理以及會員(籍)管理。本服務亦可能將個人資料與其他資料合併，用以提供並改進或開發我們的產品、服務、內容及廣告。舉例而言，我們會將您的個人資料作為以下之處理及利用："/>
      <Paragraph tab={2}
                 text="• 本服務為服務營運與客戶管理之需求，使用您的個人資料，例如：稽核、資料分析及研究等，以改進本服務之產品、服務及客戶溝通。通知您有關本服務軟體系統最新產品、服務公告、以及最新訊息。"/>
      <Paragraph tab={2} text="• 協助我們開發、交付及改進我們的產品、服務、內容及廣告。"/>
      <Paragraph tab={2}
                 text="• 傳送重要通知，例如有關重大訊息或使用條款或政策修改之通知，但這並不代表我們因此有將各種訊息逐一通知您的義務。"/>
      <Paragraph tab={2} text="• 學術研究以及其他諮詢與顧問服務。"/>
      <Paragraph tab={1} text="3.個人資料之修改"/>
      <Paragraph tab={1} text="您可隨時修改個人本服務帳號資料，但不得假冒他人，或冒用他人名義。"/>
      <Paragraph tab={1} text="4.個人資料之刪除"/>
      <Paragraph tab={1}
                 text="您可隨時要求刪除您的帳號及內含的個人資料，在您要求刪除帳號及個人資訊後，依系統運作流程經過一段時間才會從伺服器中完全刪除，而我們的備份系統為避免利用本服務進行詐騙或違法行為將保留其檔案備份。"/>
      <Paragraph tab={1} text="5.相片之處理及利用"/>
      <Paragraph tab={2} text={`
              相片收集：我們的應用程式可能會要求使用者上傳相片，以用作使用者的大頭貼或提供更完整的諮詢訊息。\n
              相片使用：我們只會使用使用者上傳的相片資訊，以提供更好的個人化使用者體驗和確認身份，並不會與任何第三方分享此資訊。\n
              相片儲存：我們會將相片資訊存儲在安全的伺服器中，以保護使用者的隱私。\n
              相片分享：我們不會與任何第三方分享使用者的相片資訊，除非為了履行使用者要求的某些特定功能。
            `}/>
      <Paragraph tab={1} text="6.您得以書面主張下列權利"/>
      <Paragraph tab={2} text={`
               查詢或請求閱覽。\n
              請求製給複製本。\n
              請求補充或更正。\n
              請求停止蒐集、處理或利用。\n
              請求刪除。
            `}/>
      <Paragraph text="二、個人資訊的揭露"/>
      <Paragraph
        text="除了下述情況，或依據相關法律或政府機構之命令外，在未獲得您的同意之前，本服務不會向任何第三人販賣、出租、交易或轉讓您所提供的個人資料、流量資料或通訊內容："/>
      <Paragraph tab={1}
                 text="1. 本服務依法律規定或為主張權利或對任何指控提出抗辯、為保護本服務的利益、打擊詐欺、執行我們的政策、保護第三人的合法權利、財產或為安全需要而揭露您的個人資料。"/>
      <Paragraph tab={1}
                 text="2. 為了向您提供您所要求的本服務產品或服務，本服務會依實際狀況，與本服務之關係企業或合作廠商分享您的個人資料與流量資訊，本服務將要求其關係企業或合作廠商遵守相關法律，並採取適當的措施來保護您的個人資料與流量資訊，但本服務並不因此為關係企業或合作廠商之行為承擔法律責任。"/>
      <Paragraph tab={1}
                 text="3. 本服務之產品或服務可能顯示合作廠商之品牌，因此，若您註冊或使用該合作廠商之產品或服務時，您同意讓本服務與合作廠商使用您的個人資料。"/>
      <Paragraph tab={1}
                 text="4. 在取得您同意之下，本服務得使用您在本服務帳號中所有活動之詳細資訊，包括但不限於流量資訊、任何通訊及交易之詳細資料。您得隨時撤回同意。但若您係以企業用戶之成員身分使用本服務相關服務者，您應同意本服務得提供您所撥打的通訊號碼與時間等詳細資料予企業用戶，且此同意不得撤回。"/>
      <Paragraph tab={1}
                 text="5. 若日後本服務轉換經營者，被第三人收購或合併，本服務將依法移交您的個人資料，倘若因此適用不同隱私權政策者，本服務將事先通知您。"/>
      <Paragraph tab={1}
                 text="6. 本服務係委託健康益友股份有限公司建置及協助蒐集、處理或利用您的個人資料，本公司對健康益友股份有限公司將善盡監督管理之責。"/>

      <Paragraph text="三、應用程式"/>
      <Paragraph text={`
              若您使用 本服務軟體系統之同時也使用其他附加功能、外掛程式或第三方之應用程式（以下簡稱「應用程式」），該等應用程式的提供者可能會取得某些您的個人資料。
              本系統不會也無法控制該等應用程式提供者如何使用您的個人資訊。因此，在安裝之前，請務必檢視該等應用程式之隱私權政策或使用條款。
            `}/>
      <Paragraph text="四、聯絡與溝通"/>
      <Paragraph text={`
              本服務有時會要求您提供有關使用經驗的資訊，這些資訊將用於衡量與改善品質。您在任何時候都沒有提供上述資料的義務。\n
              凡是在本服務軟體系統透過回饋意見表或調查而主動送出的任何及全部資訊，將會被用來審查所回饋的意見和改善本服務軟體、產品及系統。\n
              本服務可能會針對故障和服務問題與您聯絡，傳送相關訊息。本服務得以軟體或簡訊進行通知，使您知悉關於使用本服務軟體、產品及系統的服務公告、管理訊息、最終求償資訊，包括但不限於侵犯第三方權利的侵權求償。您不能選擇拒絕接受上述訊息。\n
              本服務可能以軟體或簡訊，通知您有關本服務軟體和您購買的產品最新訊息，或是其他本服務產品或本服務相關資訊。若您不願意接受上述訊息，請告知我們。如果您註冊或使用本服務的聯名品牌服務或產品，您收到的電子郵件或簡訊，可能由我們的合作夥伴廠商以本服務的名義發出。
            `}/>
      <Paragraph text="五、聯繫我們"/>
      <Paragraph
        text="如果您有任何關於隱私權政策的問題，請隨時利用本系統意見回饋方式與我們聯絡，將您的寶貴意見提供給我們。"/>
    </div>
  </div>
)